export const SAVE_TICKET = 'SAVE_TICKET'
export const TICKET_DETAILS = 'TICKET_DETAILS'